import { render, staticRenderFns } from "./AvatarViewer.vue?vue&type=template&id=058d0093&scoped=true"
import script from "./AvatarViewer.vue?vue&type=script&lang=ts"
export * from "./AvatarViewer.vue?vue&type=script&lang=ts"
import style0 from "./AvatarViewer.vue?vue&type=style&index=0&id=058d0093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d0093",
  null
  
)

export default component.exports